import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/usecase';
import { HttpResponseEntity } from '../../domain/common.models';
import { OtpValidationData } from '../../domain/pin-otp-domain.models';
import { FSWalletPinTransactionRepository } from '../../repository/fs-wallet-pin-transaction.repository';

/**
 * Validate Wallet PIN OTP Use Case - Clean Architecture Application Layer
 */
@Injectable({ providedIn: 'root' })
export class ValidateWalletPinOtpUsecase implements UseCase<OtpValidationData, HttpResponseEntity> {
    constructor(private repository: FSWalletPinTransactionRepository) {}

    /**
     * Execute OTP validation
     * @param data - Domain data for OTP validation
     * @returns Observable of domain entity
     */
    execute(data: OtpValidationData): Observable<HttpResponseEntity> {
        return this.repository.ValidateWalletPinOtp(data);
    }
}
